import { render, staticRenderFns } from "./ParcelNewProducts.vue?vue&type=template&id=31d8e36a&"
import script from "./ParcelNewProducts.vue?vue&type=script&lang=js&"
export * from "./ParcelNewProducts.vue?vue&type=script&lang=js&"
import style0 from "./ParcelNewProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports